/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { UserRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { UserListItem } from './user-list-item.model';

@Injectable()
export class UserListBusinessService implements InitViewService {

  constructor(private userContext: BuilderUserContext, private userRest: UserRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get(this.userContext.officeView ? 'officeUsers' : 'users'),
    };
  }

  findAllAsDataSource(showInactive: boolean): SlicedDataSource<UserListItem> {
    return this.userRest.findAllAsDataSource({ showInactive });
  }
}
